import find from 'lodash/find';

class AvailableCards {
    cards = [];

    constructor(cards) {
        this.cards = cards;
    }

    /**
     * @param  {Object} criteria
     * @return {{programNumber: number}}            available card
     */
    find = (criteria) => find(this.cards, criteria);
}

export default AvailableCards;
